// import { mapState } from 'vuex';
import control from './control';

const defaultData = [
  {
    _id: 1,
    imgUrl: "",
    icon: "icon-shouyeweixuanzhong",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "首页",
    url: "",
  },
  {
    _id: 2,
    imgUrl: "",
    icon: "icon-shezhi",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "工作台",
    url: "",
  },
  {
    _id: 3,
    imgUrl: "",
    icon: "icon-tab-addressbook-fill",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "通讯录",
    url: "",
  },
  {
    _id: 4,
    imgUrl: "",
    icon: "icon-tab_message_d",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "消息中心",
    url: "",
  },
  {
    _id: 5,
    imgUrl: "",
    icon: "icon-xiaoxitongzhi",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "短信中心",
    url: "",
  },
  {
    _id: 6,
    imgUrl: "",
    icon: "icon-xitongguanli",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "系统管理",
    url: "",
    children: [
      {
        "mobileUrlTypeValue": "0",
        "backgroundColor": null,
        "code": "smsblacklist",
        "icon": "icon-tk",
        "pid": "40fb4c030e63403da0ac9b99356d1743",
        "params": null,
        "url": "hmd",
        "mark_type": null,
        "imgUrl": "[]",
        "name": "黑名单",
        "_level": 2,
        "serveCode": null,
        "_id": "38f9ab69fbda41ceab510fa72704f4f1",
        "id": "38f9ab69fbda41ceab510fa72704f4f1",
        "opentype": null,
        "order": 20
      },
      {
        "mobileUrlTypeValue": "0",
        "backgroundColor": null,
        "code": "smssensitive",
        "icon": "icon-ziyuan1",
        "pid": "40fb4c030e63403da0ac9b99356d1743",
        "params": null,
        "url": "mgc",
        "mark_type": null,
        "imgUrl": "[]",
        "name": "敏感词",
        "_level": 2,
        "serveCode": null,
        "_id": "dedd25017a1943ceb5e9e9c15c7bfe0d",
        "id": "dedd25017a1943ceb5e9e9c15c7bfe0d",
        "opentype": null,
        "order": 25
      },
    ]
  },
  {
    _id: 7,
    imgUrl: "",
    icon: "icon-tab-addressbook-fill",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "通讯录",
    url: "",
  },
  {
    _id: 8,
    imgUrl: require('_platform/assets/styles/themes/img/banner-demo1.png'),
    icon: "item icon-tools",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "配置管理",
    url: "",
  },
  {
    _id: 9,
    imgUrl: "",
    icon: "icon-yingyongguanli",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "应用管理",
    url: "",
  },
];

// 新版快捷菜单
export default {
  defaultData,
  mixins: [control],
  props: {
    // 组件高度
    height: {
      type: String,
      default: "100%"
    },
    // 组件最小高度
    minHeight: {
      type: String,
      default: "none"
    },
    // 内部高度自适应
    innerHeightAuto: {
      type: Boolean,
      default: true
    },
    // 一行几列
    colNum: {
      type: Number,
      default: 5
    },
    // 一页几行
    // 0表示不限行数，且页数将固定1
    rowNum: {
      type: Number,
      default: 0
    },
    // 最多几页
    // 0表示无限制
    maxPages: {
      type: Number,
      default: 0
    },
    // 是否强制使用默认样式
    useDefaultStyle: {
      type: Boolean,
      default: false
    },
    // 是否显示更多按钮
    hasMore: {
      type: Boolean,
      default: false
    },
    // 数据来源
    dataSource: {
      type: String,
      default: "http"
    },
    dataSourceUrl: {
      type: String,
      default: ""
    },
    dataSourceList: {
      type: Array,
      default() {
        return [];
      }
    },
    displayStyle: {
      type: String,
      default: "style1"
    },
    /*****更多按钮*****/
    // 更多按钮显示文字
    moreText: {
      type: String,
      default: "更多"
    },
    // 更多按钮显示图标
    moreIcon: {
      type: String,
      default: "icon-quanbu"
    },
    // 更多按钮跳转链接
    moreUrl: {
      type: String,
      default: ""
    },
    // 更多按钮跳转方式
    moreOpentype: {
      type: String,
      default: "0"
    },
    // 二次开发传入的方法。
    itemClick: {
      type: Function,
      required: false
    },
    clickBefore: {
      type: Function,
      required: false
    },
    /*****角标设置*****/
    // 角标样式。text 显示文字; dot 显示点;
    enableMark: {
      type: String,
      default: ""
    },
    /*****图标样式*****/
    // 展示优先级。img图片优先，icon图标优先
    showPriority: {
      type: String,
      default: "img"
    },
    // 默认图标
    defaultIcon: {
      type: String,
      default: ""
    },
    iconWidth: {
      type: String,
      default: "50px"
    },
    iconHeight: {
      type: String,
      default: "50px"
    },
    iconRadius: {
      type: String,
      default: "5px"
    },
    iconBgColor: {
      type: String,
      default: "#fff"
    },
    iconBgShadow: {
      type: Boolean,
      default: true
    },
    iconFontSize: {
      type: String,
      default: "25px"
    },
    iconFontBold: {
      type: Boolean,
      default: false
    },
    iconFontColor: {
      type: String,
      default: "@normal"
    },
    iconFontShadow: {
      type: Boolean,
      default: true
    },
    /*****公共样式*****/
    cellMargin: {
      type: Array,
      default() {
        return ["5px", "5px", "5px", "5px"];
      }
    },
    cellPadding: {
      type: Array,
      default() {
        return ["0px", "0px", "0px", "0px"];
      }
    },
    cellWidth: {
      type: String,
      default: "100%"
    },
    cellRadius: {
      type: String,
      default: "0px"
    },
    cellColor: {
      type: String,
      default: ""
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    iconAndInfoOfSpacing: {
      type: String,
      default: "0px"
    }
    /*****风格1样式*****/
    /*****风格2样式*****/
    ,
    menuType:{
      // 菜单类型 1:快捷菜单2:我的菜单
      type: Number,
      default: 1
    },
    needRoleFilter:{
      // 是否角色过滤
      type: Boolean,
      default: true
    },
    dataSourceMenuCode: {
      // 菜单目录
      type: Array,
      default(){
        return []
      }
    },
    enableLevel:{
      // 菜单是否开启层级模式-文件夹模式
      type: Boolean,  
      default: false
    },
    levelMode:{
      // 菜单模式是 1:没有目录最多2层最少1层  2:最多3层，最少2层
      type: Number,
      default: 1
    },
    myMenuEditBtnStyle:{
      // 我的菜单-编辑 1:文字 2按钮
      type: Number,
      default: 1
    },
    myMenuEditUrl:{
      // 我的菜单-编辑页面地址
      type: String,
      default:"#/mobile/mdsfa/service/usermenu/mobile-edit"
    },
    myMenuEditOpenMode:{
      // 我的菜单-打开方式
      type: Number,
      default: 1
    },
    myMenuEditText:{
      type: String,
      default: "编辑"
    },
    myMenuEditIcon:{
      type: String,
      default: "icon-home-cyj"
    }
  },
  data() {
    return {
      loading: false,
      activeIndex: 0,
      sourceData: [],
      isIniting: true
    };
  },
  computed: {
    ...Vuex.mapState("cornerMark", ["badges", "menuIds"]),
    dataList() {
      if (this.isDesign && (this.dataSource !== "json" || !this.dataSourceList.length || this.menuType==2)) {
        return defaultData;
      }
      if (this.dataSource !== "json" || this.menuType==2) {
        return this.sourceData;
      }
      return this.dataSourceList;
    },
    editInfo() {
      if (this.menuType!==2 || this.myMenuEditBtnStyle==1 || this.loading) return {};
      return {
        _id: "myMenuEdit",
        imgUrl: "",
        icon: this.myMenuEditIcon,
        backgroundColor: "",
        bgColor: "",
        url: this.myMenuEditUrl,
        openType: this.myMenuEditOpenMode,
        name: this.myMenuEditText
      };
    },
    moreInfo() {
      if (!this.hasMore || this.loading) return {};
      return {
        _id: "more",
        imgUrl: "",
        icon: this.moreIcon,
        backgroundColor: "",
        bgColor: "",
        url: this.moreUrl,
        openType: this.moreOpentype,
        name: this.moreText
      };
    },
    menuList() {
      if(this.enableLevel && this.dataList?.[0]?.[0]?.[0]){
        // 目录得子级数据是一次性全处理好得，不需要再处理了
        return this.dataList;
      }
      let fn = (data, hasMore) => {
        let res = [...data];
        if (hasMore && !dsf.isEmptyObject(this.moreInfo)) {
          res.push(this.moreInfo);
        }
        if(!dsf.isEmptyObject(this.editInfo)){
          res.push(this.editInfo)
        }
        res = _.chunk(res, this.colNum);
        // 最后一行补位
        if (res.length && _.last(res).length < this.colNum) {
          let n = this.colNum - _.last(res).length;
          _.last(res).push(...new Array(n).fill({ _hide: true }));
        }

        if (this.rowNum) {
          res = _.chunk(res, this.rowNum);
          // 最后一页补位
          if (res.length && _.last(res).length < this.rowNum) {
            let n = this.rowNum - _.last(res).length;
            _.last(res).push(...new Array(n).fill([]));
          }
        } else {
          res = [res];
        }

        if (this.maxPages && res.length > this.maxPages) {
          res.length = this.maxPages;
        }
        return res;
      }
      if(this.menuType==1 && this.enableLevel && this.levelMode==2){
        // 普通快捷菜单 && 有分层 && 有目录
        let dataList = [];
        let data = this.dataList;
        if(this.isDesign || this.dataSource === "json"){
          data = this.setData(data);
        }
        let hasOther = false;
        _.forEach(data,(item)=>{
          if(item?.children){
            let hasMore = false;
            if(item._isOther || data.length==1){
              hasOther = true;
              hasMore = this.hasMore;
            }
            dataList.push({
              name:item.name,
              code: item.code,
              children: fn(item.children, hasMore)
            })
          }
        })
        if(this.hasMore && !hasOther){
          // 如果目录式有更多，但是又没有其余项
          dataList.push({
            name:"其余",
            code: null,
            children: fn([],true)
          })
        }
        return dataList;
      }else{
        return fn(this.dataList, this.hasMore);
      }
    }
  },
  watch: {
    dataList(newD, oldD) {
      if (newD && newD.length > 0 && !this.isDesign && this.enableMark) {
        this.getCornerMarkInfo(newD); //获取角标
      }
    }
  },
  created() {
    this.reloadData();
    this.$eventBus.$on("selected-app-change", this.reloadData);
  },
  methods: {
    getCornerMarkInfo(lists) {
      let cornerMarkInfo = {
        markTypes: [],
        menu_ids: []
      };
      _.forEach(lists, (list) => {
        // 类型
        let mark_type = list.mark_type;
        let markTypes = cornerMarkInfo.markTypes;
        let id = list.id;
        if (mark_type && !this.menuIds.includes(id)) {
          cornerMarkInfo.menu_ids.push(id);
          if (!markTypes.includes(mark_type)) {
            markTypes.push(mark_type);
          }
        }
      });
      let markTypes = cornerMarkInfo.markTypes;
      if (markTypes.length) {
        this.$http
          .get("cornerMark/getMarkIdList", { markTypes: markTypes.join(",") })
          .done((res) => {
            if (res.success) {
              this.$store.dispatch("cornerMark/init", {
                markId: res.data,
                menu_ids: cornerMarkInfo.menu_ids,
                type: "convenientMenu"
              });
            }
          })
          .error((res) => {
            dsf.layer.message(res?.message || "根据菜单类型获取所有角标业务ID异常", false);
          });
      }
    },
    _clickBefore(next, ...params) {
      if (this.isDesign) return;
      let res = this.clickBefore?.(...params);
      if (res && res.then) {
        res.then((r) => {
          if (r !== false) {
            next(...params);
          }
        });
      } else if (res !== false) {
        next(...params);
      }
    },
    reloadData() {
      if (this.isDesign || (this.dataSource === "json" && this.menuType!=2)) {
        return;
      }
      let params = {};
      let url = this.dataSourceUrl;
      if(this.menuType == 2){
        // 我得菜单
        url = "mobileMenu/getMobileMenu";
      }else if (this.menuType == 1 && this.dataSource == 'menuCode') {
        // 菜单目录，角色是否过滤
        url = "mobileMenu/getMenuTree";
        params = {
          menuCode: _.map(this.dataSourceMenuCode,(item)=>{return item.code}).join(","),
          queryAll: this.needRoleFilter ? 0 : 1
        }
      }
      if (url == "") {
        this.data = [];
        return;
      }
      
      this.loading = true;
      this.$http
        .get(url,params)
        .done(({ success, data, message }) => {
          if (success) {
            this.sourceData = this.setData(data);
            this.loading = false;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message, false);
        })
        .always(() => {
          this.isIniting = false;
        });
    },
    /**
     * 根据设计器配置处理数据层级
     * @param {Array} data 没处理前得数据
     * @returns Array 处理后得数据
     */
    setData(data){
      let sourceData = [];
      if (this.menuType == 2) {
        // 我的菜单模式数据不需要处理
        sourceData = data;
      } else {
        // 一层 文件夹形式展示
        let isLevelMode1 = this.menuType == 1 && this.enableLevel && this.levelMode == 1;
        // 二层 目录形式展示
        let isLevelMode2 = this.menuType == 1 && this.enableLevel && this.levelMode == 2;

        let other = {
          name: "其余",
          children: [],
          _isOther: true
        };

        let isMenu=(item)=>{
          // 是菜单，菜单是都要显示的
          return !item?.children && item.url;
        }

        let fn = (data, parent, level) => {
          _.forEach(data, (item) => {
            let _item = _.cloneDeep(item)
            delete _item.children;
            let _parent = null;
            if(isMenu(item)){
              /* 菜单 */
              if(isLevelMode2 && level==1){
                other.children.push(_item)
              }else{
                parent.push(_item);
              }
            }else{
              /* 目录 */

              // 处理过滤的情况
              if(isLevelMode1 && item?.children?.length && level==1){
                // 一层模式的一级目录显示
                parent.push(_item);
              }else if(isLevelMode2 && item?.children?.length && level<=2){
                // 二层模式的一二级目录显示
                parent.push(_item);
              }else if(!this.enableLevel && item.url){
                //没开启层级则都算菜单 ，需要显示有效的url
                parent.push(_item);
              }else{
                _parent = parent;
              }

              // 处理子级数据 以及 平铺处理
              if(item?.children?.length){
                _item.children = [];
                if(!_parent){
                  _parent = _item.children
                }
                if ((isLevelMode1 && level >= 2) || (isLevelMode2 && level >= 3) || !this.enableLevel) {
                  // （层级模式为1时 && 最多2层超出平铺） || （层级模式2时最多3层,超出平铺） || 没有开启层级，就都是平铺
                  _parent = parent;
                }
                fn(item.children, _parent, level + 1);
              }
            }
          })
        }
        fn(data, sourceData, 1);
      
        if(isLevelMode1 || isLevelMode2){
          // 有层级时，如果没有有效子级的目录清空
          _.forEachRight(sourceData,(item,index)=>{
            if(!isMenu(item) && !item?.children?.length){
              sourceData.splice(index,1)
            }
          })
        }
        if (other.children.length) {
          sourceData.push(other);
        }
      }
      return sourceData;
    },
    getImgUrl({ imgUrl, icon }) {
      if (this.showPriority == "img") {
        return imgUrl;
      }
      if (!icon || icon == "") {
        return imgUrl;
      }
      return "";
    },
    getIcon(icon) {
      if (!icon || icon == "") {
        icon = this.defaultIcon;
      }
      if (!icon) return "";
      return `${icon} icon-${icon}`;
    },
    showMark({ mark_type, id }) {
      if (this.enableMark == "") return false;
      if (this.isDesign) return true;
      if (!mark_type) return false;
      return this.badges?.id?.num || 0;
    },
    markVal({ id }) {
      if (this.isDesign) return "99+";
      let v = this.badges?.[id]?.num || 0;
      if (/^\d$/.test(v)) {
        if (parseInt(v) > 99) return "99+";
      }
      return v;
    },
    onClick(item) {
      let handler = ()=>{
        if(item._id=='myMenuEdit' && this.openEdit){
          this.openEdit();
        }else{
          this.openPage(item);
        }
      }
      if (this.itemClick) {
        let res = this.itemClick(item);
        if (res === false) return;
        if (res.then) {
          res.then((r) => {
            if (r !== false) {
              handler();
            }
          });
          return;
        }
      }
      handler();
    },
    openPage(menu) {
      let url = menu.url;
      if (!url || url == "") {
        return;
      }
      if (url.indexOf("#") == 0 && url.indexOf("#/") != 0) {
        url = url.replace("#", "#/");
      }
      url = this.$replace(url, this.local);
      let opt = {
        url,
        state: menu.openType || menu.opentype,
        cancelButtonText: "关闭",
        showCancelButton: true

      };
      if (opt.state == 3) {
        opt["title"] = menu.dialogTitle || menu.name || undefined;
        opt["width"] = menu.dialogWidth || "70vw";
        opt["height"] = menu.dialogHeight || "60vh";
      }
      if(opt.state == 4){
        // 弹层
        opt.state = 3;
        opt["title"] = menu.dialogTitle || menu.name || undefined;
        opt["width"] = "100vw"
        opt["height"] = "100vh"
      }
      this.$open(opt);
    },
    getIconStyle(item) {
      let style = dsf.mix({}, this.iconStyle);
      if (!this.useDefaultStyle) {
        if (item.backgroundColor) {
          style["background-color"] = item.backgroundColor;
        }
        if (item.foreColor) {
          style.color = item.foreColor;
        }
      }
      return style;
    }
  }
};
